<div class="msa-avatar__circle" [style.background-color]="bgColor() || null">
  {{ icon() }}
</div>
@if (name()) {
  <div class="msa-avatar__text">
    <p class="msa-avatar__name">{{ name() }}</p>
    @if (role()) {
      <p class="msa-avatar__role">{{ role() }}</p>
    }
  </div>
}
